export interface IGoalDatapointLatest {
	result_goalid: number;
	result_name: string;
	result_latestdatapointtime: string;
	result_startdate: string;
}

export const resourceNameGoalDatapointsLatest = `rpc/goal_datapoints_latest`;